// Siden brukeren skulle til da innloggingen startet. Microsoft-innloggingen og
// innloggingslenken på e-post kommer tilbake til forsiden (redirectTo er
// adressen til appen, ikke siden), så uten dette mistet en QR-kode fra
// skjermene (/skjermer/koble?kode=…) koden på veien. Innlogging med passord
// blir stående på siden og trenger det ikke.
//
// Lagret i localStorage, fordi innloggingslenken kan åpnes i en ny fane, og
// bare i et kvarter. Bare stier i appen, så det aldri blir en videresending
// ut av Pulse.

const NOKKEL = 'pulse.etterInnlogging'
export const GJELDER_MS = 15 * 60_000

function standardLager() {
  try { return window.localStorage } catch { return null }
}

export function erInternSti(sti) {
  return typeof sti === 'string'
    && sti.startsWith('/')
    && !sti.startsWith('//')
    && !sti.startsWith('/\\')
    && sti.length <= 2000
}

/** Kalles rett før innloggingen sender brukeren videre. Forsiden huskes ikke. */
export function huskStiEtterInnlogging(sti, { lager = standardLager(), naa = Date.now() } = {}) {
  if (!erInternSti(sti) || sti === '/') return
  try { lager?.setItem(NOKKEL, JSON.stringify({ sti, tid: naa })) } catch { /* lagringen er stengt */ }
}

/** Gir stien én gang, hvis den er fersk, og glemmer den. */
export function hentStiEtterInnlogging({ lager = standardLager(), naa = Date.now() } = {}) {
  let rad = null
  try {
    rad = JSON.parse(lager?.getItem(NOKKEL) || 'null')
    lager?.removeItem(NOKKEL)
  } catch {
    return null
  }
  if (!rad || !erInternSti(rad.sti)) return null
  const alder = naa - Number(rad.tid)
  if (!(alder >= 0 && alder < GJELDER_MS)) return null
  return rad.sti
}
